import React from 'react';
import { connect } from 'react-redux';
import { generateEvent } from '../../../utils/dataGrinch';
import TimerStartBeforeComponent from '../../common/TimerStartBeforeComponent';
import { getPriceRevealWebData } from '../../../Flags/selectors';
import Modal from '../../common/Modal';
import properties from '../../../modules/ajio-util/properties';
import { showModal, hideModal } from '../../../actions/modal';
import { displayValueWithSymbol } from '../../../utils/price';
import { getFormattedPrice } from '../../../utils/pdp';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { getPriceLableFromTagEngine } from '../../../utils/product';
import { replaceWithJioCDN } from '../../../utils/imageHandling';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
class Promotions extends React.Component {
  constructor(props) {
    super(props);
    this.state = { limit: 1, showMore: true };
    this.showModals = this.showModals.bind(this);
    this.showMore = this.showMore.bind(this);
    this.showLess = this.showLess.bind(this);
  }

  showMore() {
    generateEvent({
      Event: 'OfferClick',
      value: {
        Count: this.props.potentialPromotions.length,
        Operation: 'Open'
      }
    });
    this.setState({
      showMore: false,
      limit: this.props.potentialPromotions.length
    });
  }

  showLess() {
    generateEvent({
      Event: 'OfferClick',
      value: {
        Count: this.props.potentialPromotions.length,
        Operation: 'Close'
      }
    });
    this.setState({
      showMore: true,
      limit: 1
    });
  }

  showModals() {
    const { luxeEventPush } = this.props;
    generateEvent({
      Event: 'OfferClick',
      value: {
        Count: this.props.potentialPromotions.length
      }
    });
    luxeEventPush?.({
      eventName: 'pdp_view_all_coupon_click',
      event_action: 'coupon section',
      event_label: 'view all coupons',
      isViewProductDetails: 'no'
    });

    const quickViewModal = document.getElementById('quickview-modal-dialog');
    if (quickViewModal) {
      quickViewModal.style.overflowY = 'hidden';
    }

    this.setState({
      limit: this.props.potentialPromotions.length
    });
    this.props.showModal('size-guide-modal-more');
  }

  renderButton() {
    const newDesignLuxe = this.props.newDesignLuxe;
    if (!this.state.showMore) {
      return (
        <div
          className="pdp-toggle"
          aria-label="view less offers"
          onClick={this.showLess}
          role="button"
          tabIndex={0}
        >
          Less
        </div>
      );
    } else if (this.props.potentialPromotions.length > 1) {
      return (
        <>
          {newDesignLuxe ? (
            <div
              className="pdp-toggle"
              onClick={this.showModals}
              aria-label={`view ${this.props.potentialPromotions.length - 1} more offers`}
              role="button"
              tabIndex={0}
            >
              +{this.props.potentialPromotions.length - 1} More
            </div>
          ) : (
            <div
              className="pdp-toggle"
              onClick={this.showMore}
              aria-label={`view ${this.props.potentialPromotions.length - 1} more offers`}
              role="button"
              tabIndex={0}
            >
              +{this.props.potentialPromotions.length - 1} More
            </div>
          )}
        </>
      );
    }
  }

  render() {
    let {
      potentialPromotions = [],
      price = '',
      discountPrice = '',
      qvdiscountPrice = '',
      stockLevelStatus = '',
      showPriceReveal,
      isPriceReveal,
      offerPrice,
      priceRevealV2WebData,
      offerPriceShow,
      categoryTags,
      isEarlyAccessUser,
      isQuickView = false
    } = this.props;
    const {
      bbsPriceStaticText,
      priceImgSrc = {},
      luxebbsPriceStaticText,
      luxePriceImgSrc = {}
    } = priceRevealV2WebData;
    let list = potentialPromotions.slice(0, this.state.limit);
    let showPromotions = true;
    if (
      (discountPrice && price !== discountPrice) ||
      (qvdiscountPrice && price !== qvdiscountPrice)
    ) {
      showPromotions = false;
    }
    let { deviceType = '' } = this.props;
    let { location: { href = '' } = {} } = window;
    const isShowCoupon = href.includes('#gmf') && href.search('#gmf');
    const newDesignLuxe = this.props.newDesignLuxe;
    let offerListItems = list.map((data, index) => {
      let tncUrl = data.termsLink || '';
      let termsLink = tncUrl.split('|');
      termsLink = termsLink[1];
      let {
        title = '',
        description = '',
        maxSavingPrice = 0,
        promotionType = '',
        showEndTimer = false,
        timerShowDuration = '',
        endTime = '',
        serverTime = ''
      } = data;
      if (deviceType !== 'mobile') {
        description = description.replace('<a', "<a target='_blank'");
      description = description.replace(
    /<a\s([^>]*href=['"][^'"]+['"][^>]*)>(.*?)<\/a>/gi,
    function (match, linkAttrs, linkText) {
      const cleanText = linkText.replace(/<[^>]*>/g, '').trim(); // strip inner HTML tags if any
      return (
        `<a ${linkAttrs} target="_blank" rel="noopener noreferrer" aria-label="${cleanText} opens in a new tab">` +
        `${linkText} <img src="${imageBaseUrl}/static/img/open-new-tab-icon.svg" alt="" aria-hidden="true" style="margin-left:2px; vertical-align:middle;" /></a>`
      );
    }
  );
      }
      let typeOfOffer = 'coupon';
      if (promotionType) {
        typeOfOffer = 'offer';
      }

      if (typeof price === 'string') {
        price = price.replace(/[Rs. ,]/g, '');
      }

      maxSavingPrice = Math.round(maxSavingPrice);
      price = parseFloat(Math.round(price));

      if (price === maxSavingPrice || stockLevelStatus === 'outOfStock') {
        showPromotions = false;
      }
      const getItForText =
        index === 0 && (showPriceReveal || isEarlyAccessUser) ? (
          <span className="bbs-price">
            <img
              className="price-reveal-logo"
              src={newDesignLuxe ? replaceWithJioCDN(luxePriceImgSrc?.image) : replaceWithJioCDN(priceImgSrc?.image)}
              alt={
                newDesignLuxe
                  ? luxePriceImgSrc?.altText
                  : priceImgSrc?.altText || 'price reveal logo'
              }
            />
            {` ${newDesignLuxe ? luxebbsPriceStaticText : bbsPriceStaticText} `}
          </span>
        ) : !newDesignLuxe && offerPriceShow && !showPriceReveal ? (
          'Offer price '
        ) : (
          'Get it for '
        );
      const priceLabelFromTagEngine = getPriceLableFromTagEngine(categoryTags);
      const bestPriceForText =
        index === 0 && (showPriceReveal || isEarlyAccessUser) ? (
          <span className="bbs-price">
            <img
              className="price-reveal-logo"
              src={newDesignLuxe ? replaceWithJioCDN(luxePriceImgSrc?.image) : replaceWithJioCDN(priceImgSrc?.image)}
              alt={
                newDesignLuxe
                  ? luxePriceImgSrc?.altText
                  : priceImgSrc?.altText || 'price reveal logo'
              }
            />
            {` ${newDesignLuxe ? luxebbsPriceStaticText : bbsPriceStaticText} `}
          </span>
        ) : !showPriceReveal && priceLabelFromTagEngine ? (
          `${priceLabelFromTagEngine} `
        ) : (
          'Get it for '
        );

      return (
        <div
          className={
            newDesignLuxe && index === 0 && (showPriceReveal || isEarlyAccessUser)
              ? 'pdp-promo-block luxe-pdp-promo-block'
              : 'pdp-promo-block'
          }
          key={index}
        >
          {index === 0 && <div className="ic-offer-tag" aria-hidden="true" />}
          {data?.tenures && <div className="emi-offer-tag" aria-hidden="true">
            <img src={`${imageBaseUrl}/static/img/${newDesignLuxe ? 'luxe-emi-offer-tag.svg' : 'emi-offer-tag.svg'}`} alt="EMI tag" />
          </div>}
          {
            //  newDesignLuxe && index === 0 && showPriceReveal && maxSavingPrice > 0 &&
            //   <>
            //     <div className="promo-discounted-price pr-promotions luxe-pr-promotions">{getItForText}<span>{displayValueWithSymbol(maxSavingPrice)}</span></div>
            //     <hr/>
            //   </>
          }
          <div className="promo-blck">
            {!data?.tenures &&
              <div className="promo-title-blck">
                <div
                  className="promo-title"
                  aria-label={title}
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                <div className="promo-tnc-blck">
                  <span className="promo-tnc">
                    {tncUrl && (
                      <a href={`${termsLink}`} title="T&amp;C" target="_blank" aria-label="Terms & Conditions opens in a new tab">
                        T&amp;C
                        <img
                        src={`${properties.getProperty('imageBaseUrl')}/static/img/open-new-tab-icon.svg`} alt="" aria-hidden="true"
                        style={{ marginLeft: '2px', verticalAlign: 'middle' }}
                        />
                      </a>
                    )}
                  </span>
                </div>
              </div>
            }
            <div className={`promo-desc-block ${data?.tenures ? 'emi-promo-desc-block' : ''}`}>
              {/* 
                  Below code is commented for story DCFL-45517 - The offer tag 'Get it for' should be visible for all the offer box. 
                  As per the code, 'index' and 'showPromotions' variable, is forcing it to display only for first box.
              */}
              {/* {index === 0 && showPromotions && maxSavingPrice > 0 && <div className="promo-discounted-price">Get it for <span>&#8377;{maxSavingPrice}</span></div>} */}
              <Feature featureName="enable_urgency_driver_pdp">
                <Variant id="0">
                  {!newDesignLuxe && maxSavingPrice > 0 ? (
                    <div
                      className={
                        showPriceReveal || (isEarlyAccessUser && index == 0)
                          ? 'promo-discounted-price pr-promotions'
                          : offerPriceShow
                          ? 'promo-discounted-price offer-div'
                          : 'promo-discounted-price'
                      }
                    >
                      {!showPriceReveal && offerPriceShow ? (
                        <>
                          {isEarlyAccessUser && index == 0 ? (
                            <div aria-label={bestPriceForText}>
                              {bestPriceForText}
                              <span>&#8377;{maxSavingPrice}</span>
                            </div>
                          ) : (
                            <>
                              <img
                                src={`${imageBaseUrl}/static/img/percentageForDesktop.svg`}
                                className="offer-icon"
                                alt="Offer icon"
                              />
                              <span className="offer" aria-label={getItForText}>
                                {getItForText}
                              </span>
                              <span className="offer-pricess">
                                &#8377;{`${getFormattedPrice(maxSavingPrice, false)}`}
                              </span>
                            </>
                          )}
                        </>
                      ) : (
                        <div aria-label={bestPriceForText}>
                          {getItForText}
                          <span>&#8377;{maxSavingPrice}</span>
                        </div>
                      )}

                      {showEndTimer ? (
                        <TimerStartBeforeComponent
                          topTimerOrProductTimer={false}
                          endTime={endTime}
                          timerStartBefore={timerShowDuration}
                          serverTime={serverTime}
                          pageType="pdp"
                          showEndTimer={showEndTimer}
                          deviceType="desktop"
                          offerPriceShow={offerPriceShow}
                        />
                      ) : null}
                    </div>
                  ) : null}
                </Variant>
                <Variant id="1">
                  {maxSavingPrice > 0 ? (
                    <div
                      className={
                        showPriceReveal || (isEarlyAccessUser && index == 0)
                          ? 'promo-discounted-price pr-promotions'
                          : offerPriceShow
                          ? 'promo-discounted-price offer-div'
                          : 'promo-discounted-price'
                      }
                    >
                      {!showPriceReveal && offerPriceShow ? (
                        isEarlyAccessUser && index == 0 ? (
                          <div aria-label={bestPriceForText}>
                            {bestPriceForText}
                            <span>&#8377;{maxSavingPrice}</span>
                          </div>
                        ) : (
                          <>
                            <img
                              src={`${imageBaseUrl}/static/img/${
                                newDesignLuxe
                                  ? 'percentageForLuxeDesktop.svg'
                                  : 'percentageForDesktop.svg'
                              }`}
                              className="offer-icon"
                              alt="Offer icon"
                            />
                            <span className="offer" aria-label={bestPriceForText}>
                              {bestPriceForText}
                            </span>
                            <span className="offer-pricess">
                              &#8377;{`${getFormattedPrice(maxSavingPrice, false)}`}
                            </span>
                          </>
                        )
                      ) : (
                        <div aria-label={bestPriceForText}>
                          {getItForText}
                          <span>&#8377;{maxSavingPrice}</span>
                        </div>
                      )}
                      {showEndTimer ? (
                        <TimerStartBeforeComponent
                          topTimerOrProductTimer={false}
                          endTime={endTime}
                          timerStartBefore={timerShowDuration}
                          serverTime={serverTime}
                          pageType="pdp"
                          showEndTimer={showEndTimer}
                          deviceType="desktop"
                          offerPriceShow
                        />
                      ) : null}
                    </div>
                  ) : null}
                </Variant>
              </Feature>

              <div
                className="promo-desc"
                aria-label={description}
                dangerouslySetInnerHTML={{ __html: description }}
                onClick={() => localStorage.setItem('isCouponPlp', 'true')}
              />
            </div>
          </div>
        </div>
      );
    });
    return (
      <div className="pdp-promotion" role="group" aria-label='Discount Offers'>
        {!isShowCoupon && (isQuickView && newDesignLuxe ? (offerListItems ?? [])?.slice(0,1) : offerListItems)}
        {!isShowCoupon && this.renderButton()}

        {newDesignLuxe ? (
          <Modal name="size-guide-modal-more" className="size-guide-modal" isFromQuickView>
            <h2 className="coupon-head">coupons</h2>
            {!isShowCoupon && offerListItems}
          </Modal>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {} } = state;
  const { product = {}, popup: { discountPrice: qvdiscountPrice = '' } = {} } = state;
  const { discountPrice = '', offerPrice } = product;
  return {
    discountPrice,
    qvdiscountPrice,
    offerPrice,
    priceRevealV2WebData: getPriceRevealWebData(flags)
  };
};

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    },
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
}

export default Promotions = connect(mapStateToProps, mapDispatchToProps, null)(Promotions);
